// extracted by mini-css-extract-plugin
export default {"buttonCaption":"book_button_buttonCaption__mNrUt","btn_color":"book_button_btn_color__8nPTK"};